import { useState } from "react";
import { motion } from "framer-motion";
import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelope, FaPaperPlane } from "react-icons/fa";
import "./Contact.css";

const initialForm = { name: "", phone: "", email: "", loanType: "", message: "" };

const Contact = () => {
  const [form, setForm] = useState(initialForm);
  const [focused, setFocused] = useState("");
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
    setTimeout(() => {
      setSubmitted(false);
      setForm(initialForm);
    }, 2600);
  };

  return (
    <section id="contact" className="section lf-contact">
      <div className="container">
        <div className="section-head-center">
          <span className="eyebrow">Get In Touch</span>
          <h2 className="section-heading">
            Let's Start Your <span className="accent-text">Loan Journey</span>
          </h2>
          <p className="section-subtext">Reach out for a free consultation — our team responds quickly.</p>
        </div>

        <div className="lf-contact__layout">
          <motion.div
            className="lf-contact__info"
            initial={{ opacity: 0, y: 32 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.7 }}
          >
            <h3>LENT FINANCE</h3>
            <p className="lf-contact__reg">KML NO : 32090439159</p>

            <div className="lf-contact__item">
              <span className="lf-contact__icon">
                <FaMapMarkerAlt />
              </span>
              <p>
                1st Floor, Deepam Square, Chittur Road, Kadamkode,
                Karingarapully (PO), Palakkad - 678551
              </p>
            </div>

            <div className="lf-contact__item">
              <span className="lf-contact__icon">
                <FaPhoneAlt />
              </span>
              <p>
                <a href="tel:04912080455">0491-2080455</a>
                <br />
                <a href="tel:7034644555">70346 44555</a>
              </p>
            </div>

            <div className="lf-contact__item">
              <span className="lf-contact__icon">
                <FaEnvelope />
              </span>
              <p>
                <a href="mailto:Lentfinance@gmail.com">Lentfinance@gmail.com</a>
              </p>
            </div>
          </motion.div>

          <motion.form
            className="lf-contact__form"
            initial={{ opacity: 0, y: 32 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.7, delay: 0.1 }}
            onSubmit={handleSubmit}
          >
            <div className={`lf-contact__field ${focused === "name" ? "is-focused" : ""}`}>
              <label>Name</label>
              <input
                type="text"
                name="name"
                required
                value={form.name}
                onChange={handleChange}
                onFocus={() => setFocused("name")}
                onBlur={() => setFocused("")}
              />
            </div>

            <div className="lf-contact__field-row">
              <div className={`lf-contact__field ${focused === "phone" ? "is-focused" : ""}`}>
                <label>Phone</label>
                <input
                  type="tel"
                  name="phone"
                  required
                  value={form.phone}
                  onChange={handleChange}
                  onFocus={() => setFocused("phone")}
                  onBlur={() => setFocused("")}
                />
              </div>
              <div className={`lf-contact__field ${focused === "email" ? "is-focused" : ""}`}>
                <label>Email</label>
                <input
                  type="email"
                  name="email"
                  required
                  value={form.email}
                  onChange={handleChange}
                  onFocus={() => setFocused("email")}
                  onBlur={() => setFocused("")}
                />
              </div>
            </div>

            <div className={`lf-contact__field ${focused === "loanType" ? "is-focused" : ""}`}>
              <label>Loan Type</label>
              <select
                name="loanType"
                required
                value={form.loanType}
                onChange={handleChange}
                onFocus={() => setFocused("loanType")}
                onBlur={() => setFocused("")}
              >
                <option value="" disabled>
                  Select a loan type
                </option>
                <option>Gold Loan</option>
                <option>Personal Loan</option>
                <option>Business Loan</option>
                <option>Property Loan</option>
                <option>Emergency Loan</option>
              </select>
            </div>

            <div className={`lf-contact__field ${focused === "message" ? "is-focused" : ""}`}>
              <label>Message</label>
              <textarea
                name="message"
                rows="4"
                value={form.message}
                onChange={handleChange}
                onFocus={() => setFocused("message")}
                onBlur={() => setFocused("")}
              />
            </div>

            <motion.button
              type="submit"
              className="btn btn-gold lf-contact__submit"
              whileTap={{ scale: 0.96 }}
            >
              <FaPaperPlane /> {submitted ? "Enquiry Sent!" : "Send Enquiry"}
            </motion.button>
          </motion.form>
        </div>
      </div>
    </section>
  );
};

export default Contact;
